import { useSelector } from 'react-redux';
import { ProfileDataDiscriminator } from '@mews-commander/data-access';
import { RouteName } from '@mews-commander/enums';
import { getProfile } from '@mews-commander/legacy-entities/src/ducks';
import { ApplicationState } from '@mews-commander/types';
import { Dash } from '@mews-commander/ui';
import { useResolveRoute } from '@mews/routing';
import { ModalLink } from './Link';
import ProfileName from './ProfileName';

interface ProfileLinkProps {
    profileId: string;
}

const ProfileLink = ({ profileId }: ProfileLinkProps) => {
    const profile = useSelector((state: ApplicationState) => getProfile(state, { id: profileId }));
    const resolveRoute = useResolveRoute();

    if (!profile) return <Dash />;

    if (profile.data.discriminator !== ProfileDataDiscriminator.PersonalProfile) {
        return <ProfileName id={profileId} />;
    }

    const url = resolveRoute(RouteName.CustomerDetail, { id: profileId });

    return (
        <ModalLink data-profile-link={profileId} url={url}>
            <ProfileName id={profileId} />
        </ModalLink>
    );
};

export default ProfileLink;
